export default class MathConstants {
    public static GRAVITATIONAL_ACCELERATION = -9.81;
}